export default __webpack_public_path__ + "static/media/delete.473fd013.svg";